import { Alert, Box, Button, Card, CardContent, Stack, TextField } from '@mui/material';
import { Title, useNotify } from 'react-admin';
import { useState } from 'react';

import { readProjectSettings, writeProjectSettings, type ProjectSettings } from '../admin/adminSettings';

export function ProjectSettingsPage() {
    const notify = useNotify();
    const [settings, setSettings] = useState<ProjectSettings>(() => readProjectSettings());

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
            <Card sx={{ width: '100%', maxWidth: 920, borderRadius: 4, boxShadow: '0 24px 80px rgba(15, 23, 42, 0.12)' }}>
                <Title title="Project Settings" />
                <CardContent sx={{ p: { xs: 2.5, md: 4 } }}>
                    <Stack spacing={2}>
                        <Alert severity="info">Mock test generation sends enum names as text and relies on backend model binding.</Alert>
                        <TextField
                            label="Project Name"
                            value={settings.projectName}
                            onChange={(e) => setSettings((s) => ({ ...s, projectName: e.target.value }))}
                            fullWidth
                        />
                        <TextField
                            label="Public Site URL"
                            value={settings.publicSiteUrl}
                            onChange={(e) => setSettings((s) => ({ ...s, publicSiteUrl: e.target.value }))}
                            fullWidth
                        />
                        <TextField
                            label="Default Language"
                            value={settings.defaultLanguage}
                            onChange={(e) => setSettings((s) => ({ ...s, defaultLanguage: e.target.value }))}
                            fullWidth
                        />
                        <TextField
                            label="Admin API URL"
                            value={settings.adminApiBaseUrl}
                            onChange={(e) => setSettings((s) => ({ ...s, adminApiBaseUrl: e.target.value }))}
                            fullWidth
                        />
                        <TextField
                            label="Admin API Version"
                            value={settings.adminApiVersion}
                            onChange={(e) => setSettings((s) => ({ ...s, adminApiVersion: e.target.value }))}
                            fullWidth
                        />
                        <TextField
                            label="Admin API Token"
                            value={settings.adminApiToken}
                            onChange={(e) => setSettings((s) => ({ ...s, adminApiToken: e.target.value }))}
                            fullWidth
                            type="password"
                        />
                        <TextField
                            label="Live Exam Task API Controller"
                            value={settings.destinationExamTaskApiController}
                            onChange={(e) =>
                                setSettings((s) => ({ ...s, destinationExamTaskApiController: e.target.value }))
                            }
                            helperText="Example: AdminExamTaskLiveEdit"
                            fullWidth
                        />
                        <TextField
                            label="Live Exam Task Primary Action Label"
                            value={settings.destinationExamTaskPrimaryActionLabel}
                            onChange={(e) =>
                                setSettings((s) => ({ ...s, destinationExamTaskPrimaryActionLabel: e.target.value }))
                            }
                            fullWidth
                        />
                        <TextField
                            label="Live Exam Task Primary Action Path"
                            value={settings.destinationExamTaskPrimaryActionPath}
                            onChange={(e) =>
                                setSettings((s) => ({ ...s, destinationExamTaskPrimaryActionPath: e.target.value }))
                            }
                            helperText="Relative API action path, for example: update"
                            fullWidth
                        />
                        <TextField
                            label="Live Exam Task Secondary Action Label"
                            value={settings.destinationExamTaskSecondaryActionLabel}
                            onChange={(e) =>
                                setSettings((s) => ({ ...s, destinationExamTaskSecondaryActionLabel: e.target.value }))
                            }
                            fullWidth
                        />
                        <TextField
                            label="Live Exam Task Secondary Action Path"
                            value={settings.destinationExamTaskSecondaryActionPath}
                            onChange={(e) =>
                                setSettings((s) => ({ ...s, destinationExamTaskSecondaryActionPath: e.target.value }))
                            }
                            helperText="Relative API action path, for example: unpublish"
                            fullWidth
                        />
                        <Button
                            variant="contained"
                            onClick={() => {
                                writeProjectSettings(settings);
                                notify('Settings saved', { type: 'info' });
                            }}
                        >
                            Save
                        </Button>
                    </Stack>
                </CardContent>
            </Card>
        </Box>
    );
}
